export const REGISTER_SLOT_PORTAL =
  'extensionsSlots.registerSlotPortal' as const;
export const UNREGISTER_SLOT_PORTAL =
  'extensionsSlots.unregisterSlotPortal' as const;
export const UPDATE_SLOT_PORTAL_PROPS =
  'extensionsSlots.updateSlotPortalProps' as const;
export const REGISTER_SLOT_PORTAL_NODE =
  'extensionsSlots.registerSlotPortalNode' as const;
export const UNREGISTER_SLOT_PORTAL_NODE =
  'extensionsSlots.unregisterSlotPortalNode' as const;
